import type { PublicRuntimeConfig } from 'app.types';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { environmentName }: PublicRuntimeConfig = publicRuntimeConfig;

export class UrlService {
  private readonly domain: string;
  constructor({ main }: { main?: boolean }) {
    let domain = 'https://stage-app.welltory.com';

    if (environmentName === 'production') {
      domain = 'https://app.welltory.com';

      if (main) {
        domain = 'https://welltory.com';
      }
    }

    // if (global.location) {
    //   domain = global.location.origin;
    // }

    this.domain = domain;
  }
  getUrl(pathname: string): string {
    return `${this.domain}${pathname}`;
  }

  getDomain(): string {
    return this.domain;
  }
}
